<template>
    <div class="container">
        <order-list :orders="archivedOrders"></order-list>
    </div>
</template>

<script>
    import {mapGetters} from "vuex"
    export default {
        name: 'archived-orders',
        data() {
            return {}
        },
        computed: Object.assign({}, mapGetters(['archivedOrders'])),
    };
</script>



// WEBPACK FOOTER //
// ArchivedOrders.vue?7ca89c07